export type IAutomaticRenewals = {
  _id?: string;
  renterInfo: {
    renterId: string;
    renterName: string;
    renterCpf: string;
  };
  vehicleInfo?: {
    vehicleId?: string;
    licensePlate?: string;
  };
  paymentInfo?: {
    lastPaymentId?: string;
    lastPaymentDate?: Date;
  };
  status: AUTO_RENEWAL_LOG_STATUS;
  errorMessage?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  details?: any;
  createdAt: Date;
};

export enum AUTO_RENEWAL_LOG_STATUS {
  SUCCESS = "success",
  FAILED = "failed",
  SKIPPED = "skipped",
}
